// src/pages/Home/Home.jsx
import "./Home.css";
import React from 'react';
import cmsClient from '../../lib/cmsClient';

import Slider from "../../components/Slider/Slider";
import ServiceCardsHome from "../../components/ServicesCardsHome/ServicesCardsHome";
import Accordion from "../../components/Accordion/Accordion";

function Home() {
  const [page, setPage] = React.useState({ blocks:[], theme:{} });
  React.useEffect(()=>{ (async()=>{
    try{
      const key = 'public_home_version';
      // First fetch (no-cache) to get latest and its version
      const j = await cmsClient.getPage('home');
      if(j?.success){
        const data = j.data || { blocks:[], theme:{} };
        setPage(data);
        const ver = data.version || 0;
        const prev = parseInt(localStorage.getItem(key) || '0', 10);
        if(ver && ver !== prev){
          localStorage.setItem(key, String(ver));
          // Re-fetch with explicit version as cache-buster (optional but explicit)
          const j2 = await cmsClient.getPage('home', { version: ver });
          if(j2?.success) setPage(j2.data || data);
        }
      }
    }catch(_e){}
  })(); }, []);
  const hasBlocks = (page.blocks || []).length > 0;

  return (
    <>
      <div>
        {hasBlocks ? page.blocks.map((b) => {
        if(b.type === 'hero') return (
          <section key={b.id} className="home-hero" style={{ background:b.bg, color:b.fg }}>
            <div className="container">
              <h1>{b.title}</h1>
              <p>{b.subtitle}</p>
              {b.ctaText && <a href={b.ctaLink} className="btn-primary">{b.ctaText}</a>}
            </div>
          </section>
        );
        if(b.type === 'features') return (
          <section key={b.id} className="home-features">
            <div className="container">
              <h2>{b.title}</h2>
              <div className="grid3">
                {(b.items||[]).map((it, idx) => (
                  <div key={idx} className="card">
                    <div className="icon">{it.icon}</div>
                    <div className="t">{it.title}</div>
                    <div className="d">{it.text}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        );
        if(b.type === 'cta') return (
          <section key={b.id} className="home-cta">
            <div className="container center">
              <h3>{b.title}</h3>
              {b.ctaText && <a href={b.ctaLink} className="btn-primary">{b.ctaText}</a>}
            </div>
          </section>
        );
        return null;
        }) : (
          <>
            <Slider />
            <ServiceCardsHome />
            <Accordion />
          </>
        )}
      </div>
      {/* Footer global dans App.js */}
    </>
  );
}

export default Home;
